import * as tslib_1 from "tslib";
import { OnInit, OnChanges, SimpleChanges, OnDestroy, EventEmitter } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { FormBuilder, Validators } from "@angular/forms";
import { distinctUntilChanged, flatMap, takeUntil } from "rxjs/operators";
import { Select, Store } from "@ngxs/store";
import { AddOrderTemplateItem, CreateOrderTemplate, FetchOrderTemplatesMin } from "../../actions/product-details.actions";
import { ClearOrderTemplateState } from "../../../order-templates/actions/order-templates.actions";
import { Router } from "@angular/router";
const ɵ0 = (state) => state.productDetails.createOrderTemplatePending, ɵ1 = (state) => state.productDetails.createOrderTemplateError, ɵ2 = (state) => state.productDetails.orderTemplatesList, ɵ3 = (state) => state.productDetails.fetchOrderTemplatesMinPending, ɵ4 = (state) => state.productDetails.fetchOrderTemplatesMinSuccess, ɵ5 = (state) => state.productDetails.fetchOrderTemplatesMinError, ɵ6 = (state) => state.productDetails.addOrderTemplateItemPending;
export class ProductAddOrderTemplatesComponent {
    constructor(fb, store, router) {
        this.fb = fb;
        this.store = store;
        this.router = router;
        this.onProductQuantityChange = new EventEmitter();
        this.onModalClose = new EventEmitter();
        this.ngUnsubscribe = new Subject();
        this.newPricingDetails = null;
        this.store.dispatch(new FetchOrderTemplatesMin());
    }
    ngOnInit() {
        this.fetchPricingForQuantity(1);
        this.form = this.fb.group({
            'quantity': [1, [Validators.required, Validators.min(1)]],
            'newTemplateName': [null, [Validators.required, Validators.maxLength(120)]]
        });
        this.form.get('quantity').valueChanges.pipe(takeUntil(this.ngUnsubscribe), distinctUntilChanged())
            .subscribe(_ => this.fetchPricingForQuantity(_));
    }
    ngOnChanges(changes) {
        if (changes.orderTemplatePricing &&
            changes.orderTemplatePricing.currentValue &&
            changes.orderTemplatePricing.currentValue.hasOwnProperty(this.selectedVariant.sku)) {
            this.newPricingDetails = changes.orderTemplatePricing.currentValue[this.selectedVariant.sku];
        }
    }
    addProductToOrderTemplate(templateName) {
        this.store.dispatch(new AddOrderTemplateItem({ sku: this.selectedVariant.sku, quantity: this.form.get('quantity').value, orderTemplate: templateName }))
            .pipe(flatMap(() => this.store.dispatch(new FetchOrderTemplatesMin())))
            .subscribe(data => { });
    }
    fetchPricingForQuantity(quantity) {
        this.onProductQuantityChange.emit({ sku: this.selectedVariant.sku, quantity: quantity });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    createTemplate() {
        this.store.dispatch(new CreateOrderTemplate(this.form.controls.newTemplateName.value))
            .pipe(flatMap(() => this.store.dispatch(new FetchOrderTemplatesMin())))
            .subscribe(data => {
            this.form.reset();
            this.form.controls.quantity.setValue(1);
        });
    }
    clearState() {
        this.store.dispatch(new ClearOrderTemplateState());
    }
    includeSelectedVariant(template) {
        if (template != null && template.items.length > 0) {
            let items = template.items.filter(el => el.sku == this.selectedVariant.sku);
            return items.length > 0;
        }
        return false;
    }
    variantQuantityInTemplate(template) {
        let item = template.items.find(el => el.sku == this.selectedVariant.sku);
        return item.quantity;
    }
    closeModal() {
        this.onModalClose.emit();
    }
    goToTemplateDetails(id) {
        this.router.navigate(['order-templates', 'details', id]);
    }
}
tslib_1.__decorate([
    Select(ɵ0),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "createOrderTemplatePending$", void 0);
tslib_1.__decorate([
    Select(ɵ1),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "createOrderTemplateError$", void 0);
tslib_1.__decorate([
    Select(ɵ2),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "orderTemplatesList$", void 0);
tslib_1.__decorate([
    Select(ɵ3),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "fetchOrderTemplatesMinPending$", void 0);
tslib_1.__decorate([
    Select(ɵ4),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "fetchOrderTemplatesMinSuccess$", void 0);
tslib_1.__decorate([
    Select(ɵ5),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "fetchOrderTemplatesMinError$", void 0);
tslib_1.__decorate([
    Select(ɵ6),
    tslib_1.__metadata("design:type", Observable)
], ProductAddOrderTemplatesComponent.prototype, "addOrderTemplateItemPending$", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
